import React from "react";
import Logo from "./Logo";
import { TileStripDivider } from "./TileMotif";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#F5F0E8] border-t border-[#E5DFD3]"
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8 pt-10">
        <TileStripDivider className="opacity-60" />
      </div>
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-10 md:py-12 flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left">
        <Logo size="sm" />
        <p
          data-testid="footer-tagline"
          className="text-sm md:text-base text-[#1A1A1A] tracking-wide"
        >
          <span className="font-black">Play.</span>{" "}
          <span className="font-light">Learn.</span>{" "}
          <span className="font-black">Master.</span>
        </p>
        <p className="text-xs text-[#6b6a64]">
          © {new Date().getFullYear()} MahjongTrainer · Hong Kong
        </p>
      </div>
    </footer>
  );
};

export default Footer;
